import { getAliasCategoriesSelector } from 'modules/categories/selectors'
import getDomainMapKeyFromPathReduxUtil from 'modules/redux/utils/get-domain-map-key-from-path'
import getDomainPathFromSectionReduxUtil from 'modules/redux/utils/get-domain-path-from-section'
import getInstanceSectionSelector from 'modules/section/selectors/get-instance'
import { getInstancesSectionUtil } from 'modules/section/utils'
import getUserSelector from 'modules/users/selectors/get-user'

import { createSelector } from 'reselect'
import { getObjectUtil, compactArrayUtil } from 'packages/src'

/**
 * Gets a selector that selects the items given the section and options.
 * @param  {string} [sectionArg]
 * @param  {Object} [options={}]
 *         {Object} [SECTIONS_OPTION.FEATURED]
 * @returns {Function}
 */
function getInstancesSectionSelector (sectionArg, options = {}) {
  return (state, props) => {
    let isNew
    let category
    let section = sectionArg
    if (!section) {
      const {
        route,
        match
      } = props
      isNew = route.path.endsWith('/new')
      section = route.section
      category = match.params.category
    }

    if (category) {
      category = getAliasCategoriesSelector(
        section, category
      )(state)
    }

    const domainName = getDomainPathFromSectionReduxUtil(section)
    return getInstancesSectionUtil({
      domain: state[domainName],
      category,
      options,
      isNew
    })
  }
}

/**
 * Gets the user with the matching `name` param.
 * @returns {Selector}
 */
function getInstanceUserSectionSelector () {
  return createSelector(
    (state, props) => getUserSelector(
      getObjectUtil(
        props.instance || getInstanceSectionSelector()(state, props),
        'data.user.data.name'
      )
    )(state),
    (user) => user
  )
}

/**
 * Gets the instance's recommended.
 * @param  {string} domainName
 * @returns {Array}
 */
function getInstanceRecommendedSectionSelector (domainName) {
  return createSelector(
    state => state[domainName],
    getInstanceSectionSelector(),
    (domain, instance) => {
      // Get the recommended Instance pointers
      const recommended = getObjectUtil(instance, 'data.recommended') || []
      // Get the recommended Instances
      const domainMapKey = getDomainMapKeyFromPathReduxUtil(domainName)
      return compactArrayUtil(
        recommended.map(r => domain.data[r.data[domainMapKey]])
      )
    }
  )
}

export {
  getInstancesSectionSelector,
  getInstanceUserSectionSelector,
  getInstanceRecommendedSectionSelector
}
